import axiosInstance from './axiosInstance';

export async function getClients(page = 1, limit = 10) {
  const response = await axiosInstance.get('/clients/get-clients.php', {
    params: { page, limit },
  });
  return response.data;
}

export async function getClientDetail(id) {
  const response = await axiosInstance.get(`/clients/get-client-detail.php?id=${id}`);
  return response.data;
}

export async function createClient(data) {
  const response = await axiosInstance.post('/clients/create-client.php', data);
  return response.data;
}

export async function editClient(data) {
  const response = await axiosInstance.post('/clients/edit-client.php', data);
  return response.data;
}

export async function deactivateClient(id, isActive) {
  const response = await axiosInstance.post('/clients/deactivate-client.php', {
    id_client: id,
    is_active: isActive,
  });
  return response.data;
}

export async function searchClients(query) {
  const response = await axiosInstance.get('/clients/search-clients.php', {
    params: { q: query },
  });
  return response.data.clients || [];
}